module.exports = __webpack_public_path__ + "img/gfx-step-1_x3.e0676b27.webp";